'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { FormControl } from '@andritzot/metris-web-ui/inputs/form-control';
import { InputLabel } from '@andritzot/metris-web-ui/inputs/input-label';
import { Select } from '@andritzot/metris-web-ui/inputs/select';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { MenuItem } from '@andritzot/metris-web-ui/navigation/menu/menu-item';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface PriorityFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

const PRIORITY_OPTIONS = [
  { value: 0, label: 'Low' },
  { value: 1, label: 'Medium' },
  { value: 2, label: 'High' },
];

export function PriorityField({ viewOnly, control }: Readonly<PriorityFieldProps>) {
  return (
    <Box sx={{ py: 0.75, width: '100%' }}>
      <Controller
        name="priority"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FieldActionsWrapper>
            <FormControl fullWidth size="small" disabled={viewOnly}>
              <InputLabel id="priority-label">Status Priority</InputLabel>
              <Select
                labelId="priority-label"
                label="Status Priority"
                value={value ?? 0}
                onChange={(e) => {
                  const num = Number(e.target.value);
                  if (num === 0 || num === 1 || num === 2 || num === 3) onChange(num);
                }}
              >
                {PRIORITY_OPTIONS.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
